import { forwardRef, ReactElement, useMemo } from 'react';
import ComboBox, { BaseComboBoxProps } from '~/components/inputs/Select/ComboBox';

export interface SimpleComboboxOption {
  action?: ReactElement;
  endIcon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  description?: string;
  media?: ReactElement;
  label: string;
  value: string;
  isDisabled?: boolean;
}

export interface SimpleComboBoxProps extends BaseComboBoxProps {
  onChange: (value: string | null) => void;
  options: SimpleComboboxOption[];
  value: string | null;
}

const valueToId = (value: string | null) => value ?? '';

const SimpleComboBox = forwardRef(
  ({ onChange, options, value, ...baseProps }: SimpleComboBoxProps, ref?: React.Ref<HTMLDivElement>) => {
    const optionsWithId = useMemo(() => options.map((option) => ({ ...option, id: option.value })), [options]);

    return (
      <ComboBox<string>
        {...baseProps}
        ref={ref}
        onChange={onChange}
        options={optionsWithId}
        value={value}
        valueToId={valueToId}
      />
    );
  },
);

export default SimpleComboBox;
